"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabourUnion = void 0;
const Tags_1 = require("../../Tags");
const CardName_1 = require("../../../CardName");
const CardType_1 = require("../../CardType");
const CardRenderer_1 = require("../../render/CardRenderer");
const Card_1 = require("../../Card");
const DiscardCards_1 = require("../../../deferredActions/DiscardCards");
const Size_1 = require("../../render/Size");
const Resources_1 = require("../../../Resources");
class LabourUnion extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.LABOUR_UNION,
            tags: [Tags_1.Tags.BUILDING],
            startingMegaCredits: 55,
            metadata: {
                cardNumber: 'R51',
                description: 'You start with 55 M€.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(55);
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect(undefined, (eb) => {
                            eb.plate('Standard projects').startEffect.megacredits(4);
                        });
                        ce.vSpace();
                        ce.effect('After you pay for a standard project, except selling patents, you gain 4 M€. At generation end, discard down to 6 cards.', (eb) => {
                            eb.cards(1).startEffect.text('MAX 6 AT GEN END', Size_1.Size.SMALL);
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    onStandardProject(player, projectType) {
        if (projectType.name !== CardName_1.CardName.SELL_PATENTS_STANDARD_PROJECT) {
            player.addResource(Resources_1.Resources.MEGACREDITS, 4, { log: true });
        }
    }
    onProductionPhase(player) {
        if (player.cardsInHand.length > 6) {
            const cardsToDiscard = player.cardsInHand.length - 6;
            player.game.defer(new DiscardCards_1.DiscardCards(player, cardsToDiscard));
        }
        return undefined;
    }
}
exports.LabourUnion = LabourUnion;
//# sourceMappingURL=LabourUnion.js.map